/**************************************************************************************************/
/*   File: /src/app/shared/index.ts                                                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as components from './components/index';
import * as directives from './directives/index';
import * as enums from './enums/index';
import * as models from './models/index';
import * as services from './services/index';

export {
    components,
    directives,
    models,
    services,
    enums
};